module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal"
  }, [_c('v-dialog', {
    attrs: {
      "value": _vm.value1,
      "max-width": "800"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input1')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline",
    attrs: {
      "align": "center"
    }
  }, [_vm._v("\n        Search result for keysearch:   \n        "), _c('strong', [_vm._v(_vm._s(_vm.keysearch))])]), _vm._v(" "), _c('v-card-text', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": 5,
      "options": _vm.pagination,
      "server-items-length": _vm.totalItems
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(ref) {
        var items = ref.items;

        return [_c('tbody', _vm._l((items), function(item, index) {
          return _c('tr', {
            key: item.name
          }, [_c('td', [_c('a', {
            attrs: {
              "href": 'https://www.instagram.com/' + item.instagramHandle,
              "target": "_blank"
            }
          }, [_vm._v("@" + _vm._s(item.instagramHandle))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.totalFollowers))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.engagementRate) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.audienceCredibility) + "%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.relevancyScore))]), _vm._v(" "), _c('td', [(!item.isSelected) ? _c('v-btn', {
            attrs: {
              "color": "secondary",
              "fab": "",
              "x-small": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.selectInfluencer(item, index)
              }
            }
          }, [_c('v-icon', [_vm._v("done")])], 1) : _vm._e(), _vm._v(" "), (item.isSelected) ? _c('v-btn', {
            attrs: {
              "color": "red",
              "fab": "",
              "x-small": "",
              "dark": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                return _vm.deselectInfluencer(item, index)
              }
            }
          }, [_c('v-icon', [_vm._v("clear")])], 1) : _vm._e()], 1)])
        }), 0)]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green darken-1",
      "text": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      }
    }
  }, [_vm._v("Done")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-292dbd0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/PairingInfluencer/InfluencerListModal.vue
// module id = 2050
// module chunks = 0